// https://codemirror.net/5/mode/index.html
// https://github.com/codemirror/legacy-modes/blob/main/mode/README.md
// https://gist.github.com/rooks/6a13affb544ef8bc338b49af7d018318 csv mode

// TODO: more https://github.com/codemirror/legacy-modes

import type { LanguageSupport } from "@codemirror/language";

import { StreamLanguage } from "@codemirror/language";
import * as m from "./notepad2/menu-notepad2";
import { getFileExt } from "./fileutil";
import { len, throwIf } from "./util";

// see Style_UpdateLexerLang in Styles.c

let langSql: LanguageSupport;
// TODO: different dialects: MySQL, PostgreSQL etc.
async function getLangSql(): Promise<LanguageSupport> {
  if (!langSql) {
    const m = await import("@codemirror/lang-sql");
    langSql = m.sql();
  }
  return langSql;
}

let langCpp: LanguageSupport;
async function getLangCpp(): Promise<LanguageSupport> {
  if (!langCpp) {
    const m = await import("@codemirror/lang-cpp");
    langCpp = m.cpp();
  }
  return langCpp;
}

let langPhp: LanguageSupport;
async function getLangPhp(): Promise<LanguageSupport> {
  if (!langPhp) {
    const m = await import("@codemirror/lang-php");
    langPhp = m.php();
  }
  return langPhp;
}

let langPython: LanguageSupport;
async function getLangPython(): Promise<LanguageSupport> {
  if (!langPython) {
    const m = await import("@codemirror/lang-python");
    langPython = m.python();
  }
  return langPython;
}

let langRust: LanguageSupport;
async function getLangRust(): Promise<LanguageSupport> {
  if (!langRust) {
    const m = await import("@codemirror/lang-rust");
    langRust = m.rust();
  }
  return langRust;
}

let langSvelte: LanguageSupport;
async function getLangSvelte(): Promise<LanguageSupport> {
  if (!langSvelte) {
    const m = await import("@replit/codemirror-lang-svelte");
    langSvelte = m.svelte();
  }
  return langSvelte;
}

let langJson: LanguageSupport;
async function getLangJson(): Promise<LanguageSupport> {
  if (!langJson) {
    const m = await import("@codemirror/lang-json");
    langJson = m.json();
  }
  return langJson;
}

let langXml: LanguageSupport;
async function getLangXml(): Promise<LanguageSupport> {
  if (!langXml) {
    const m = await import("@codemirror/lang-xml");
    langXml = m.xml();
  }
  return langXml;
}

let langJavascript: LanguageSupport;
async function getLangJavaScript(): Promise<LanguageSupport> {
  if (!langJavascript) {
    const m = await import("@codemirror/lang-javascript");
    langJavascript = m.javascript();
  }
  return langJavascript;
}

let langCSS: LanguageSupport;
async function getLangCSS(): Promise<LanguageSupport> {
  if (!langCSS) {
    const m = await import("@codemirror/lang-css");
    langCSS = m.css();
  }
  return langCSS;
}

let langHTML: LanguageSupport;
async function getLangHTML(): Promise<LanguageSupport> {
  if (!langHTML) {
    const m = await import("@codemirror/lang-html");
    langHTML = m.html();
  }
  return langHTML;
}

let langJava: LanguageSupport;
async function getLangJava(): Promise<LanguageSupport> {
  if (!langJava) {
    const m = await import("@codemirror/lang-java");
    langJava = m.java();
  }
  return langJava;
}

let langVue: LanguageSupport;
async function getLangVue(): Promise<LanguageSupport> {
  if (!langVue) {
    const m = await import("@codemirror/lang-vue");
    langVue = m.vue();
  }
  return langVue;
}

let langMarkdown: LanguageSupport;
async function getLangMarkdown(): Promise<LanguageSupport> {
  if (!langMarkdown) {
    const m = await import("@codemirror/lang-markdown");
    langMarkdown = m.markdown();
  }
  return langMarkdown;
}

let langLua: StreamLanguage<any>;
async function getLangLua(): Promise<StreamLanguage<any>> {
  if (!langLua) {
    const m = await import("@codemirror/legacy-modes/mode/lua");
    langLua = StreamLanguage.define(m.lua);
  }
  return langLua;
}

let langGo: StreamLanguage<any>;
async function getLangGo(): Promise<StreamLanguage<any>> {
  if (!langGo) {
    const m = await import("@codemirror/legacy-modes/mode/go");
    langGo = StreamLanguage.define(m.go);
  }
  return langGo;
}

let langDiff: StreamLanguage<any>;
async function getLangDiff(): Promise<StreamLanguage<any>> {
  if (!langDiff) {
    const m = await import("@codemirror/legacy-modes/mode/diff");
    langLua = StreamLanguage.define(m.diff);
  }
  return langDiff;
}

let langScss: StreamLanguage<any>;
async function getLangScss(): Promise<StreamLanguage<any>> {
  if (!langScss) {
    const m = await import("@codemirror/legacy-modes/mode/css");
    langScss = StreamLanguage.define(m.sCSS);
  }
  return langScss;
}

let langLess: StreamLanguage<any>;
async function getLangLess(): Promise<StreamLanguage<any>> {
  if (!langLess) {
    const m = await import("@codemirror/legacy-modes/mode/css");
    langLess = StreamLanguage.define(m.less);
  }
  return langLess;
}

let langOctave: StreamLanguage<any>;
async function getLangOctave(): Promise<StreamLanguage<any>> {
  if (!langOctave) {
    const m = await import("@codemirror/legacy-modes/mode/octave");
    langOctave = StreamLanguage.define(m.octave);
  }
  return langOctave;
}

let langShell: StreamLanguage<any>;
async function getLangShell(): Promise<StreamLanguage<any>> {
  if (!langShell) {
    const m = await import("@codemirror/legacy-modes/mode/shell");
    langShell = StreamLanguage.define(m.shell);
  }
  return langShell;
}

let langRuby: StreamLanguage<any>;
async function getLangRuby(): Promise<StreamLanguage<any>> {
  if (!langRuby) {
    const m = await import("@codemirror/legacy-modes/mode/ruby");
    langRuby = StreamLanguage.define(m.ruby);
  }
  return langRuby;
}

let langCSharp: StreamLanguage<any>;
async function getLangCSharp(): Promise<StreamLanguage<any>> {
  if (!langCSharp) {
    const m = await import("@codemirror/legacy-modes/mode/clike");
    langCSharp = StreamLanguage.define(m.csharp);
  }
  return langCSharp;
}

async function getLexerDynamic(id: string): Promise<LanguageSupport | StreamLanguage<any> | null> {
  switch (id) {
    case m.IDM_LEXER_RUBY:
      return await getLangRuby();
    case m.IDM_LEXER_JS:
    case m.IDM_LEXER_ACTIONSCRIPT:
      return await getLangJavaScript();
    case m.IDM_LEXER_HTML:
      return await getLangHTML();
    case m.IDM_LEXER_CSS:
      return await getLangCSS();
    case m.IDM_LEXER_JAVA:
      return await getLangJava();
    case m.IDM_LEXER_VUE:
      return await getLangVue();
    case m.IDM_LEXER_MARKDOWN:
    case m.IDM_LEXER_MARKDOWN_GITHUB:
    case m.IDM_LEXER_MARKDOWN_GITLAB:
    case m.IDM_LEXER_MARKDOWN_PANDOC:
      return await getLangMarkdown();
    case m.IDM_LEXER_LUA:
      return await getLangLua();
    case m.IDM_LEXER_GO:
      return await getLangGo();
    case m.IDM_LEXER_DIFF:
      return await getLangDiff();
    case m.IDM_LEXER_SCSS:
      return await getLangScss();
    case m.IDM_LEXER_LESS:
      return await getLangLess();
    case m.IDM_LEXER_OCTAVE:
    case m.IDM_LEXER_MATLAB:
    case m.IDM_LEXER_SCILAB:
      return await getLangOctave();
    case m.IDM_LEXER_BASH:
    case m.IDM_LEXER_CSHELL:
    case m.IDM_LEXER_M4:
      return await getLangShell();
    case m.IDM_LEXER_CSHARP:
      return await getLangCSharp();
    case m.IDM_LEXER_JSON:
      return await getLangJson();
    case m.IDM_LEXER_XML:
      return await getLangXml();
    case m.IDM_LEXER_RUST:
      return await getLangRust();
    case m.IDM_LEXER_SQL:
      return await getLangSql();
    case m.IDM_LEXER_PYTHON:
      return await getLangPython();
    case m.IDM_LEXER_CPP:
      return await getLangCpp();
    case m.IDM_LEXER_SVELTE:
      return await getLangSvelte();
    case m.IDM_LEXER_PHP:
      return await getLangPhp();
  }

  return null;
}

const langs: [LanguageSupport | StreamLanguage<any> | null, string, ...string[]][] = [
  [null, m.IDM_LEXER_JS, ".js", ".ts", ".jsx", ".tsx"],
  [null, m.IDM_LEXER_ACTIONSCRIPT, ".as"],
  [
    null,
    m.IDM_LEXER_JSON,
    ".json",
    ".har",
    ".ipynb",
    ".wxcp",
    ".jshintrc",
    ".eslintrc",
    ".babelrc",
    ".prettierrc",
    ".stylelintrc",
    ".jsonld",
    ".jsonc",
    ".arcconfig",
    ".arclint",
    ".jscop",
  ],
  [null, m.IDM_LEXER_CSS, ".css"],
  [
    null,
    m.IDM_LEXER_HTML,
    ".html",
    "htm",
    "shtml",
    "xhtml",
    "asp",
    "aspx",
    "jsp",
    "mht",
    "htd",
    "htt",
    "hta",
    "htc",
    "cfm",
    "tpl",
    "jd",
  ],
  [null, m.IDM_LEXER_JAVA, ".java"],
  [null, m.IDM_LEXER_VUE, ".vue"],
  [null, m.IDM_LEXER_MARKDOWN, ".md", ".markdown"],
  [null, m.IDM_LEXER_MARKDOWN_GITHUB, ".md", ".markdown"],
  [null, m.IDM_LEXER_MARKDOWN_GITLAB, ".md", ".markdown"],
  [null, m.IDM_LEXER_MARKDOWN_PANDOC, ".md", ".markdown"],
  [
    null,
    m.IDM_LEXER_XML,
    ".xml",
    ".xsl",
    ".xslt",
    ".xsd",
    ".dtd",
    ".rss",
    ".svg",
    ".xul",
    ".axl",
    ".rdf",
    ".xaml",
    ".resx",
    ".plist",
    ".pom",
    ".mm",
    ".xrc",
    ".fbp",
    ".wxml",
  ],
  [null, m.IDM_LEXER_RUST, ".rs"],
  [null, m.IDM_LEXER_SQL, ".sql"],
  [null, m.IDM_LEXER_PYTHON, ".py"],
  [null, m.IDM_LEXER_CPP, ".c", ".cpp", ".c++", ".cxx", ".h", ".hpp", ".hxx"],
  [null, m.IDM_LEXER_SVELTE, ".svelte"],
  [null, m.IDM_LEXER_PHP, ".php"],
  [null, m.IDM_LEXER_LUA, ".lua"],
  [null, m.IDM_LEXER_GO, ".go"],
  [null, m.IDM_LEXER_DIFF, ".diff"],

  [null, m.IDM_LEXER_SCSS, ".scss"],
  [null, m.IDM_LEXER_LESS, ".less"],
  [null, m.IDM_LEXER_OCTAVE, ".octave"],
  [null, m.IDM_LEXER_MATLAB, ".m"],
  [null, m.IDM_LEXER_SCILAB, ".sce", ".sci"],
  [null, m.IDM_LEXER_BASH, ".bash", ".sh"],
  [null, m.IDM_LEXER_CSHELL, ".csh", ".tcsh"],
  [null, m.IDM_LEXER_M4, ".m4", ".ac"],
  [
    null,
    m.IDM_LEXER_RUBY,
    ".rb",
    ".ruby",
    ".rbw",
    ".rake",
    ".rjs",
    ".gemspec",
    ".podspec",
    ".cr",
  ],
  [null, m.IDM_LEXER_CSHARP, ".cs", ".csx", ".vala", ".vapi"],

  /*
  // TODO: to figure out
  [null, m.IDM_LEXER_CSV, ""],
  [null, m.IDM_LEXER_HSS, ""],
  [null, m.IDM_LEXER_JSP, ""],
  [null, m.IDM_LEXER_ASPX_CS, ""],
  [null, m.IDM_LEXER_ASPX_VB, ""],
  [null, m.IDM_LEXER_ASP_VBS, ""],
  [null, m.IDM_LEXER_ASP_JS, ""],
  [null, , ""], // TODO: shell?
  [null, m.IDM_LEXER_XSD, ""],
  [null, m.IDM_LEXER_XSLT, ""],
  [null, m.IDM_LEXER_DTD, ""],
  [null, m.IDM_LEXER_ANT_BUILD, ""],
  [null, m.IDM_LEXER_MAVEN_POM, ""],
  [null, m.IDM_LEXER_MAVEN_SETTINGS, ""],
  [null, m.IDM_LEXER_IVY_MODULE, ""],
  [null, m.IDM_LEXER_IVY_SETTINGS, ""],
  [null, m.IDM_LEXER_PMD_RULESET, ""],
  [null, m.IDM_LEXER_CHECKSTYLE, ""],
  [null, m.IDM_LEXER_APACHE, ""],
  [null, m.IDM_LEXER_TOMCAT, ""],
  [null, m.IDM_LEXER_WEB_JAVA, ""],
  [null, m.IDM_LEXER_STRUTS, ""],
  [null, m.IDM_LEXER_HIB_CFG, ""],
  [null, m.IDM_LEXER_HIB_MAP, ""],
  [null, m.IDM_LEXER_SPRING_BEANS, ""],
  [null, m.IDM_LEXER_JBOSS, ""],
  [null, m.IDM_LEXER_PROPERTY_LIST, ""],
  [null, m.IDM_LEXER_ANDROID_MANIFEST, ""],
  [null, m.IDM_LEXER_ANDROID_LAYOUT, ""],
  */
];

async function getDelayedLang(
  langInfo: [LanguageSupport | StreamLanguage<any> | null, string, ...string[]]
): Promise<LanguageSupport | StreamLanguage<any> | null> {
  if (langInfo[0] === null) {
    langInfo[0] = await getLexerDynamic(langInfo[1]);
  }
  return langInfo[0];
}

export async function getCMLangFromFileName(
  fileName: string
): Promise<LanguageSupport | StreamLanguage<any> | null> {
  const name = fileName.toLowerCase();
  const ext = getFileExt(fileName).toLowerCase();
  for (let langInfo of langs) {
    for (let i = 2; i < len(langInfo); i++) {
      let lext = langInfo[i];
      throwIf(lext === "");
      if (lext === name || lext === ext) {
        return await getDelayedLang(langInfo);
      }
    }
  }
  return null;
}

export async function getCMLangFromLexer(
  lexer: string
): Promise<LanguageSupport | StreamLanguage<any> | null> {
  for (let lang of langs) {
    for (let i = 2; i < len(lang); i++) {
      if (lang[1] == lexer) {
        return getDelayedLang(lang);
      }
    }
  }
  return null;
}

export function getLangName(lang: any): string {
  if (lang.name) {
    return lang.name;
  }
  return lang.language.name;
}
